import Vue from 'vue';
import Vuex from 'vuex';
import App from '../main';

import setting from './modules/setting';

Vue.use(Vuex);
// 初始化store
const sxwStore = new Vuex.Store({
  modules: {
    setting
  },
  state: {
    // 用户信息，全局使用
    user: null,

    isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent),

    // 系统级别【"kinder(幼儿园)"、"school(中小学)"】
    systemLevel: null,
    // 管理员级别【"admin(教育局管理员)"、"street(街道管理员)"、"school(学校管理员)"】
    adminLevel: null,

    ajaxErrorLogs: [],
    // GlobalLoad 组件使用
    globalLoad: {
      loading: false,
      text: '玩命加载中...'
		},

		// 街道社区学校信息
		streetList: []
  },
  mutations: {
    // 提交commit修改userInfo
    setUserInfo(state, data) {
      state.user = data;
    },

    setIsMobile(state, data) {
      state.isMobile = data;
    },

    setSystemLevel(state, data) {
      state.systemLevel = data;
    },
    setAdminLevel(state, data) {
      state.adminLevel = data;
    },
    setSystemInfo(state, data) {
      state.user.systemInfo = data;
		},

		// 保存街道社区信息
		setStreetList(state, data) {
      state.streetList = data;
    },

    // ######## 统一处理api错误 ########
    ajaxErrorMessage(state, data) {
      try {
        console.log('-> 统一处理api错误 ajaxErrorMessage', state.isMobile, JSON.stringify(data));
        let { message } = data;
        if (state.isMobile) {
          App.$toast.hide();
          App.$toast.failed(message);
        } else {
          App.$message.error(message);
        }
        state.ajaxErrorLogs.push(data);
      } catch (e) {
        console.error('-> 统一处理api错误', e);
      }
    },

    // 全局loading
    setGlobalLoad(state, load) {
      state.globalLoad = load;
    }
  }
});

export default sxwStore;
